class ProductQuantity extends HTMLElement{constructor(){super()}connectedCallback(){this.input=this.querySelector("input"),this.valueChangedListener(),this.updateValueListener()}valueChangedListener(){this.input.on("change",()=>{var t=parseInt(this.input.value);window.trigger(`theme:product:${this.dataset.id}:quantityChanged`,t)})}updateValueListener(){window.on(`theme:product:${this.dataset.id}:updateQuantity`,({detail:t})=>{this.input.value=t,this.input.trigger("change")})}}const productQuantityEl=customElements.get("product-quantity-root");productQuantityEl||customElements.define("product-quantity-root",ProductQuantity);



// Code below has been copied from Beyond 5.0


class Cart extends HTMLElement {
	static basket = {};
	static sections = window.location.pathname === Shopify.routes.cart ? ["cart-drawer", "cart-desktop", "cart-mobile"] : ["cart-drawer"];
	constructor() {
		super()
	}
	connectedCallback() {
		this.abort_controllers = {}, this.checkout_button = this.querySelector(".cart--checkout-button"), this.note = this.querySelector(".cart--notes--textarea"), this.view = this.dataset.view, this.toggleLoadingOnSubmit(), this.addUpdateHtmlListener(), this.note && this.addNoteListeners(), "drawer" === this.view && (this.summary = this.querySelector(".cart--summary"), new ResizeObserver(() => {
			requestAnimationFrame(() => this.updateSummaryHeight())
		}).observe(this))
	}
	toggleLoadingOnSubmit() {
		this.checkout_button.on("click", () => this.checkout_button.setAttribute("aria-busy", !0)), window.on("pagehide", t => {
			t.persisted && this.checkout_button.setAttribute("aria-busy", !1)
		})
	}
	addUpdateHtmlListener() {
		window.on(`theme:cart:${this.view}:updateHtml`, ({
			detail: {
				section: t
			}
		}) => {
			t && (this.swapInNewContent(t.parse(".cart--form")), "drawer" === this.view && this.updateSummaryHeight(), this.toggleLoadingDisplay(!0), window.trigger(`theme:transition:reload:cart-${this.view}`), window.trigger("theme:cart:updated", this))
		})
	}
	addNoteListeners() {
		this.note.on("input", () => {
			this.updateNote(this.note.value), window.trigger("theme:cart:noteUpdate", {
				source: this.view,
				note: this.note.value
			})
		}), window.on("theme:cart:noteUpdate", ({
			detail: {
				source: t,
				note: e
			}
		}) => {
			t !== this.view && (this.note.value = e)
		})
	}
	async updateNote(t) {
		this.abort_controllers.note && this.abort_controllers.note.abort(), this.abort_controllers.note = new AbortController;
		try {
			await fetch(`${Shopify.routes.cart_update}.js`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json"
				},
				body: JSON.stringify({
					note: t
				}),
				signal: this.abort_controllers.note.signal
			})
		} catch {}
	}
	toggleLoadingDisplay(t, e) {
		var i;
		!t && e && (i = this.querySelector(`.cart--item[data-line-num='${e}'] input`)) && i.setAttribute("aria-busy", !0), t ? this.checkout_button.removeAttribute("disabled") : this.checkout_button.setAttribute("disabled", "disabled"), this.dynamic_checkout_buttons && this.dynamic_checkout_buttons.setAttribute("data-disabled", !t)
	}
	async tryToUpdateQuantity(t, e) {
    console.log("Updating quantity for line:", t, "New quantity:", e);
		this.toggleLoadingDisplay(!1, t);
		try {
			await this.updateQuantity(t, e) || 0 === e || this.showQuantityError(t)
		} catch {}
	}
	showQuantityError(t) {
		var e = this.querySelector(`.cart--item[data-line-num='${t}']`);
		e && e.querySelector(".cart--error").setAttribute("aria-hidden", !1)
	}
	async updateQuantity(t, e) {
		this.abort_controllers.line_num && this.abort_controllers.line_num.abort(), this.abort_controllers.line_num = new AbortController;
		var i = this.querySelector(`.cart--item[data-line-num='${t}']`),
			{
				management: s,
				policy: r,
				quantity: a
			} = i.dataset,
			o = parseInt(a),
			n = i.getAttribute("data-variant-id"),
			h = this.getOtherVariantQuantities(i, n),
			l = o < e + h && "shopify" === s && "continue" !== r;
		l && (e = o - h);
		try {
			var d, c, u, p = await fetch(`${Shopify.routes.cart_change}.js`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json"
				},
				body: JSON.stringify({
					line: t,
					quantity: e,
					sections: Cart.sections
				}),
				signal: this.abort_controllers.line_num.signal
			});
			if (p.ok) return {
				items: d,
				item_count: c,
				sections: u
			} = await p.json(), Cart.fillBasket(d), Cart.updateTotals(c), Cart.updateAllHtml(u), !l;
			throw new Error(p.statusText)
		} catch {
			throw new Error("aborted")
		}
	}
	getOtherVariantQuantities(t, e) {
		var i = this.querySelectorAll(`.cart--item[data-variant-id='${e}']`);
		let s = 0;
		return i.not(t).forEach(t => {
			var e = t.querySelector(".quantity-selector--input");
			s += parseInt(e.value)
		}), s
	}
	swapInNewContent(t) {
		var e = this.querySelector(".cart--body"),
			i = t.querySelector(".cart--body"),
			s = this.querySelector(".cart--shipping"),
			r = t.querySelector(".cart--shipping"),
			a = (s && r && s.replaceWith(r), i = this.swapInImages(e, i), e && i && e.replaceWith(i), this.querySelector(".cart--totals")),
			o = t.querySelector(".cart--totals");
		a && o && a.replaceWith(o)
	}
	updateSummaryHeight() {
		this.style.setProperty("--summary-height", `${this.summary.offsetHeight}px`)
	}
	swapInImages(r, t) {
		var e = t.querySelectorAll(".cart--item");
		return 0 !== e.length && (e.forEach(t => {
			var e = t.getAttribute("data-variant-id"),
				i = t.querySelector(".cart--item--image"),
				s = r.querySelector(`[data-variant-id='${e}'] .cart--item--image`);
			s && i && i.replaceWith(s)
		}), t)
	}
	static updateAllHtml(t) {
		Object.entries(t).forEach(([t, e]) => {
			window.trigger(`theme:cart:${t.replace(/^cart-/,"")}:updateHtml`, {
				section: e
			})
		})
	}
	static async addItems(t = {}, e = !1) {
		var i = await fetch(`${Shopify.routes.cart_add}.js`, t);
		if (!i.ok) throw new Error(i.statusText);
		var {
			id: s,
			items: r,
			quantity: a,
			sections: o
		} = await i.json();
		r ? r.forEach(({
			id: t,
			quantity: e
		}) => Cart.updateBasket(t, e)) : s && a && Cart.updateBasket(s, a), e && Cart.openDrawer(e), Cart.updateTotals(Object.values(Cart.basket).reduce((t, e) => t + e, 0)), Cart.updateAllHtml(o)
	}
	static openDrawer(t) {
		window.on("theme:cart:updated", () => {
			requestAnimationFrame(() => {
				window.trigger("theme:transition:reset:cart-drawer"), Drawer.open("right", "cart-drawer", t)
			})
		}, {
			once: !0
		})
	}
	static async fetchBasket() {
		var t = await fetch(`${Shopify.routes.cart}.js`);
		if (!t.ok) throw new Error(t.statusText);
		var e = (await t.json()).items;
		Cart.fillBasket(e)
	}
	static updateBasket(t, e) {
		Cart.basket[t] = e, window.trigger("theme:cart:productAdded", t)
	}
	static fillBasket(t) {
		Cart.basket = {}, t.forEach(({
			id: t,
			quantity: e
		}) => Cart.basket[t] = e)
	}
	static updateTotals(t) {
		document.querySelector("[data-cart-count]")?.setAttribute("data-cart-count", t), document.querySelector(".layout--viewport")?.setAttribute("data-cart-empty", 0 === t)
	}
}
customElements.define("cart-element", Cart);




class ProductBuyButtons extends HTMLElement {
	constructor() {
		super()
	}
	connectedCallback() {
		this.abort_controller = new AbortController, this.button_texts = this.querySelectorAll(".product-buy-buttons--cta-text"), this.cart_type = this.getAttribute("data-cart-type"), this.change_button = this.querySelector(".product-buy-buttons--drawer-change"), this.drawer = this.querySelector(".product-buy-buttons--drawer"), this.drawer_disabled = !1, this.drawer_variant = this.querySelector(".product-buy-buttons--drawer-variant"), this.form = this.closest("form"), this.input = this.querySelector(".product-buy-buttons--input"), this.main_product = "true" === this.getAttribute("data-main-product"), this.last_child = document.querySelector(".layout--main-content > *:last-child"), this.primary_buttons = this.querySelectorAll(".product-buy-buttons--primary"), this.smart_button = this.querySelector(".product-buy-buttons--smart"), this.translations = JSON.parse(this.querySelector("script").textContent), this.initResizeObserver(), this.addToCartListener(), this.updateViewListener(), this.drawer && (this.addIntersectionObservers(), this.windowListeners(), this.change_button) && this.changeListener()
	}
	disconnectedCallback() {
		this.abort_controller.abort()
	}
	addToCartListener() {
		this.closest("form").on("submit", async t => {
			var e = t.target.querySelector("[name=quantity]"),
				i = Utils.getQuantity(this.dataset.id, this.input.dataset, e.value);
			if ("drawer" !== this.cart_type && !1 !== i || (t.preventDefault(), t.stopPropagation()), i) {
				this.primary_buttons.forEach(t => t.setAttribute("aria-busy", !0));
				var s = new FormData(t.target),
					r = {
						method: "POST",
						headers: {
							"Content-Type": "application/x-www-form-urlencoded"
						},
						body: `${new URLSearchParams(s).toString()}&sections=${Cart.sections.join(",")}`
					};
				try {
					await Cart.addItems(r, "drawer" === this.cart_type ? this.primary_buttons[0] : null), "drawer" === this.cart_type && this.primary_buttons.forEach(t => t.setAttribute("aria-busy", !1))
				} catch (t) {
					throw this.primary_buttons.forEach(t => t.setAttribute("aria-busy", !1)), new Error(t)
				}
			}
		})
	}
	updateViewListener() {
		window.on(`theme:product:${this.dataset.id}:variantChanged`, ({
			detail: {
				variant: t
			}
		}) => {
			this.drawer_variant && (this.drawer_variant.innerText = t.public_title), t.id && t.available ? (this.selectVariant(t), this.updateView(!0, !0)) : t.id && !t.available ? (this.selectVariant(t), this.updateView(!1, !0)) : this.updateView(!1, !1)
		})
	}
	addIntersectionObservers() {
		new IntersectionObserver(([{
			isIntersecting: t,
			boundingClientRect: e
		}]) => {
			!t && e.top <= 0 ? this.openDrawer() : t && this.closeDrawer()
		}, {
			threshold: 0
		}).observe(this.primary_buttons[0]), new IntersectionObserver(([{
			isIntersecting: t
		}]) => {
			t ? (this.reached_bottom = !0, this.closeDrawer()) : this.reached_bottom && (this.reached_bottom = !1, this.openDrawer())
		}, {
			threshold: .6
		}).observe(this.last_child)
	}
	openDrawer() {
		this.pending_open = !0, this.drawer_disabled || this.drawer.setAttribute("aria-hidden", !1)
	}
	closeDrawer() {
		this.pending_open = !1, this.drawer.setAttribute("aria-hidden", !0)
	}
	windowListeners() {
		window.on("theme:popup:opened theme:drawer:left:opening theme:drawer:right:opening theme:feedback:opened", () => {
			this.drawer_disabled = !0, this.drawer.setAttribute("aria-hidden", !0)
		}, {
			signal: this.abort_controller.signal
		}), window.on("theme:popup:closed theme:drawer:left:closed theme:drawer:right:closed theme:feedback:closed", () => {
			this.drawer_disabled = !1, this.pending_open && this.drawer.setAttribute("aria-hidden", !1)
		}, {
			signal: this.abort_controller.signal
		})
	}
	changeListener() {
		this.change_button.on("click", () => {
			var {
				top: t,
				height: e
			} = this.primary_buttons[0].getBoundingClientRect();
			window.scrollTo({
				top: window.scrollY + t - window.innerHeight + e,
				behavior: "smooth"
			})
		})
	}
	initResizeObserver() {
		new ResizeObserver(() => {
			requestAnimationFrame(() => {
				this.form.style.setProperty("--buy-buttons--height", `${this.offsetHeight}px`)
			})
		}).observe(this)
	}
	selectVariant({
		id: t,
		sku: e,
		inventory_management: i,
		inventory_policy: s,
		inventory_quantity: r
	}) {
		this.input.value = t, this.input.setAttribute("data-sku", e), this.input.setAttribute("data-management", i), this.input.setAttribute("data-policy", s), this.input.setAttribute("data-quantity", r)
	}
	updateView(t, e) {
		t ? (this.primary_buttons.forEach(t => t.removeAttribute("disabled")), this.button_texts.forEach(t => t.textContent = this.translations.add_to_cart), this.smart_button && this.smart_button.setAttribute("aria-hidden", !1)) : (this.primary_buttons.forEach(t => t.setAttribute("disabled", !0)), this.smart_button && this.smart_button.setAttribute("aria-hidden", !0), this.button_texts.forEach(t => t.textContent = e ? this.translations.out_of_stock : this.translations.unavailable))
	}
}
customElements.define("product-buy-buttons-element", ProductBuyButtons);







class QuantitySelector extends HTMLElement {
	constructor() {
		super()
	}
	connectedCallback() {
		this.minus = this.querySelector(".quantity-selector--minus"), this.plus = this.querySelector(".quantity-selector--plus"), this.input = this.querySelector(".quantity-selector--input"), this.remove = this.querySelector(".quantity-selector--remove"), this.inputListener(), this.plusListener(), this.minusListener(), this.type = this.getAttribute("data-type"), "cart" === this.type ? (this.cart = this.closest(".cart--root"), this.line_num = this.closest(".cart--item").getAttribute("data-line-num"), this.removeListener()) : "product" === this.type && this.updateValueListener()
	}
	inputListener() {
		let e;
		this.input.on("keydown", t => {
			var e = t.which;
			(e < 48 || 57 < e) && (e < 37 || 40 < e) && 8 !== e && 9 !== e && t.preventDefault()
		}), this.input.on("focusin", async ({
			target: t
		}) => e = parseInt(t.value)), this.input.on("focusout", async () => {
			var t = parseInt(this.input.value);
			isNaN(t) || t === e ? this.input.value = e : (this.input.value = t, this.callback(t))
		})
	}
	plusListener() {
		this.plus.on("click keydown", t => {
			var e;
			"keydown" === t.type && "Enter" !== t.key || (t.preventDefault(), e = 0 < parseInt(this.input.value) ? parseInt(this.input.value) + 1 : 1, this.input.value = e, this.callback(e))
		})
	}
	minusListener() {
		this.minus.on("click keydown", t => {
			var e;
			"keydown" === t.type && "Enter" !== t.key || (t.preventDefault(), 1 !== parseInt(this.input.value) && (e = 1 < parseInt(this.input.value) - 1 ? parseInt(this.input.value) - 1 : 1, this.input.value = e, this.callback(e)))
		})
	}
	removeListener() {
		this.remove.on("click", () => this.callback(0))
	}
	updateValueListener() {
		window.on(`theme:product:${this.dataset.id}:updateQuantity`, ({
			detail: t
		}) => {
			this.input.value = t, this.input.trigger("focusout")
		})
	}
	callback(t) {
		"cart" === this.type ? this.cart.tryToUpdateQuantity(this.line_num, t) : "product" === this.type && window.trigger(`theme:product:${this.dataset.id}:quantityChanged`, t)
	}
}
customElements.define("quantity-selector", QuantitySelector);
